import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="heading01 type01">
            <h1>{{ 'user.Skills' | translate }}</h1>
            <ul class="actions01">
                <li><a class="btn add" ng-click="vm.openAddModal()">{{ 'user.Add skill' | translate }}</a></li>
            </ul>
        </div>
        <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
        <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="vm.list.items.length">
            <thead>
            <tr>
                <th>{{ 'user.Skill' | translate }}</th>
                <th>{{ 'user.Levels' | translate }}</th>
                <th>{{ 'user.Competences' | translate }}</th>
                <th>{{ 'user.Roles' | translate }}</th>
                <th>{{ 'user.Employees' | translate }}</th>
                <th class="actions">&nbsp;</th>
            </tr>
            </thead>
            <tbody>
                <tr ng-repeat-start="item in vm.list.items">
                    <td><a ui-sref="authorized.user.competence.skill.view({ id: item.id })">{{ item.name }}</td>
                    <td></td>
                    <td>{{ item.competenceCount }}</td>
                    <td></td>
                    <td>{{ item.employeeCount }}</td>
                    <td class="actions">
                        <a class="btn edit" ui-sref="authorized.user.competence.skill.view({ id: item.id })">{{ 'general.Edit' | translate }}</a>
                        <a class="btn delete" ng-click="vm.deleteSkill(item)">{{ 'general.Delete' | translate }}</a>
                    </td>
                </tr>
                <tr ng-repeat-start="l2item in item.children" class="level02">
                    <td><a ui-sref="authorized.user.competence.skill.view({ id: l2item.id })">{{ l2item.name }}</td>
                    <td></td>
                    <td>{{ l2item.competenceCount }}</td>
                    <td></td>
                    <td>{{ l2item.employeeCount }}</td>
                    <td class="actions">
                        <a class="btn edit" ui-sref="authorized.user.competence.skill.view({ id: l2item.id })">{{ 'general.Edit' | translate }}</a>
                        <a class="btn delete" ng-click="vm.deleteSkill(l2item)">{{ 'general.Delete' | translate }}</a>
                    </td>
                </tr>
                <tr ng-repeat-start="l3item in l2item.children" class="level03">
                    <td><a ui-sref="authorized.user.competence.skill.view({ id: l3item.id })">{{ l3item.name }}</td>
                    <td></td>
                    <td>{{ l3item.competenceCount }}</td>
                    <td></td>
                    <td>{{ l3item.employeeCount }}</td>
                    <td class="actions">
                        <a class="btn edit" ui-sref="authorized.user.competence.skill.view({ id: l3item.id })">{{ 'general.Edit' | translate }}</a>
                        <a class="btn delete" ng-click="vm.deleteSkill(l3item)">{{ 'general.Delete' | translate }}</a>
                    </td>
                </tr>
                <tr ng-repeat-start="l4item in l3item.children" class="level04">
                    <td><a ui-sref="authorized.user.competence.skill.view({ id: l4item.id })">{{ l4item.name }}</td>
                    <td></td>
                    <td>{{ l4item.competenceCount }}</td>
                    <td></td>
                    <td>{{ l4item.employeeCount }}</td>
                    <td class="actions">
                        <a class="btn edit" ui-sref="authorized.user.competence.skill.view({ id: l4item.id })">{{ 'general.Edit' | translate }}</a>
                        <a class="btn delete" ng-click="vm.deleteSkill(l4item)">{{ 'general.Delete' | translate }}</a>
                    </td>
                </tr>
                <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td><td></td><td></td></tr>
                <tr ng-repeat-end ng-hide="true"><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            </tbody>
        </table>
`
})
export default class {
    constructor ($translate, SkillResource, ListFactory, ModalService, DATATABLES) {
        this.$translate = $translate;
        this.SkillResource = SkillResource;
        this.ModalService = ModalService;
        this.ListFactory = ListFactory;
        this.DATATABLES = DATATABLES;
    }

    $onInit () {
        this.list = this.ListFactory.createWithPagination(this.SkillResource.tree.bind(this.SkillResource));
        this.list.fetch();
    }

    openAddModal () {
        return this.ModalService.open({
            template: `<modals-competence-skill-add on-close="vm.$uibModalInstance.dismiss()"
                on-update="vm.update()" class="wrapper" />`,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.update = () => {
                    this.$uibModalInstance.close();
                };
            }
        }).then(() => {
            this.list.fetch();
        });
    }

    deleteSkill (skill) {
        const deleteMessage = this.$translate.instant('user.Do you want to delete skill?');
        this.ModalService.confirm(deleteMessage, 'medium')
            .then(() =>
                this.SkillResource.delete({ id: skill.id }).$promise.then(() => this.list.fetch())
            )
        ;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/competence/skill/list/index.js